import React, { useEffect } from 'react';
import { graphql } from 'gatsby';

// Components
import { Layout, NetworkBanner, NetworkContent, SEO } from '../../components';
import { Heading } from '../../components/a11y';

// Utils
import { seoTitleTemplates } from '../../utils/networkMap';
import { noSpaces } from '../../utils/helpers';

// Interfaces
import { INetwork } from '../../utils/models';

// Styles
import './network.scss';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';

let tealiumTrackPageLoad;
if (typeof window !== 'undefined') {
  const { trackPageLoad } = initTealiumTracker({ debugMode: true });
  tealiumTrackPageLoad = trackPageLoad;
}

interface IProps {
  data: any;
  pageContext: {
    network: INetwork;
  };
}

export const NETWORK_QUERY = graphql`
  query($providerId: String!, $providerName: String!) {
    allSOD {
      networkAssets(providerId: $providerId, providerName: $providerName) {
        items {
          assetType
          id
          altIds {
            tmsRootId
            tmsSeriesId
          }
          title
          imageUrl
          offer {
            providerName
          }
        }
      }
    }
  }
`;

const Network = ({ data, pageContext }: IProps) => {
  const { items } = data.allSOD.networkAssets;
  const { network } = pageContext;
  const { displayName, description, seoTitleFormat } = network;

  // Tealium Page Tracking
  useEffect(() => {
    tealiumTrackPageLoad({
      pagename: 'Network Details Page',
      section: 'TV',
      pagetype: 'Network Page',
      sc_reporting_suite: 'charterspectrumondemand',
    });
  }, []);

  return (
    <div className="network-page-wrapper">
      <Layout
        className="network-page"
        header={<NetworkBanner network={network} />}
      >
        <SEO
          title={`${seoTitleTemplates[seoTitleFormat]} ${displayName}`}
          description={description}
        />

        <Heading className="visually-hidden">{displayName}</Heading>

        <p className="network-page__description">{network.description}</p>

        <NetworkContent
          items={items}
          networkName={noSpaces(displayName).toLowerCase()}
        />
      </Layout>
    </div>
  );
};

export default Network;
